<div class="pagetitle">
    <h1>{{ pageTitle }}</h1>
    <nav>
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="[homeUrl]">Home</a>
            </li>
            <li class="breadcrumb-item active">{{breadcrumb}}</li>        
        </ol>
    </nav>
</div>
